// Component: Timeline
// Author: Jay
import * as React from 'react';
import TimelineNPM from '@rotaryintl/component-timeline';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';

export default function Timeline(props) {
  let data = [];
  props.fields?.children?.forEach((element) => {
    data.push({ header: <Text field={element.fields?.Header} />, description: <RichText field={element.fields?.Description} /> });
  });

  return (
    <>
      <TimelineNPM title={<Text field={props.fields?.Title} />} data={data} />
    </>
  );
}
